@let tags = visTags();
<div class="vz-tag layout center" [ngClass]="'vz-tag-' + tagSize()" [title]="tags && tags.length ? tags[tags.length - 1].desc || '' : ''">
    @if (tags && tags.length) {
        @for (t of tags; track t.id) {
            @if (t.icon || t.text || $last || $first) {
                <div class="layout center vzt-part"
                    [class.vzt-start]="$first"
                    [class.vzt-end]="$last"
                    [class.vzt-tag-nogroup]="tags.length == 1"
                    [class.vzt-icon-only]="t.icon && !t.text"
                    [style.background-color]="t.color">
                    @if (t.icon) {
                        <i class="vzt-icon" [ngClass]="t.icon"></i>
                    }
                    @if (t.text) {
                        <!-- <span class="elli-wrap">
                            <span class="vzt-text elli">{{ t.text }}</span>
                        </span> -->
                        <span class="vzt-text elli">{{ t.text ? t.text.length > 15 ? t.text.substring(0, 15) + '…' : t.text : '' }}</span>
                    }
                </div>
            }
            @if (!$last) {
                <div class="vzt-separator" [style.border-left-color]="t.color"></div>
                <div class="vzt-separator2" [style.border-top-color]="tags[$index + 1].color" [style.border-bottom-color]="tags[$index + 1].color"></div>
            }
        }
    }
    @else {
        <div class="vzt-single" style="background-color: #ccc" [title]="'Тег не найден, #' + this.tagId()">
            <span class="vzt-text ph025">{{ '???' }}</span>
        </div>
    }
</div>
